import { InputNumber } from "primereact/inputnumber";
import { Skeleton } from "primereact/skeleton";

// export const APP_BASE_URL = "https://tgwk9h35-5001.inc1.devtunnels.ms";
// export const APP_BASE_URL = "https://tolerant-complete-starling.ngrok-free.app";

export const APP_BASE_URL = "https://api.nexawage.com";

// export const APP_BASE_URL = "https://b037b8a7ec86.ngrok-free.app";

export const ASSET_PATH = APP_BASE_URL;

export const IMAGE_BASEURL = APP_BASE_URL + "front/assets/img/search_image.png";

// PAGINATION
//default pagination Row data
export const defaultRowOptions = 25;

// default pagination row data in dashboard
export const defaultRowOptionsInDashboard = 5;

//default PerPageRow options
export const defaultPageRowOptions = [5, 10, 25, 50, 100];

//paginatior entries showing
export const showingEntries = "Showing {first} to {last} of {totalRecords}";

//paginator links & dropdown
export const paginatorLinks = "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown";

//Month List
export const monthShortNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

// PAGINATION

//date picker options
export const datePickerOptions = [
  { label: "Custom", value: "custom" },
  { label: "Today", value: "today" },
  { label: "Yesterday", value: "yesterday" },
  { label: "Last 7 days", value: "last7day" },
  { label: "Last 30 days", value: "last30days" },
  { label: "Last 90 days", value: "last90days" },
  { label: "Last month", value: "lastmonth" },
  { label: "Last year", value: "lastyear" },
  { label: "Week to date", value: "weektodate" },
  { label: "Month to date", value: "monthtodate" },
  { label: "Year to date", value: "yeartodate" },
];

// client pay scheme
export const paySchemaOptions = [
  { name: "Monthly", value: "Monthly" },
  { name: "Semi Monthly", value: "Semi Monthly" },
  { name: "Bi Weekly", value: "Bi Weekly" },
];

// user cycle status dropdown
export const cycleStatusDropdown = [
  { name: "Not Added", value: "Not Added" },
  { name: "Added", value: "Added" },
];

// gst added status
export const gstAddedStatusDropdown = [
  { name: "Gst Included", value: "true" },
  { name: "Gst Excluded", value: "false" },
];

// client charge invoice status
export const clientChargeInvoiceStatusDropdown = [
  { name: "Created", value: "created" },
  { name: "Paid", value: "paid" },
  { name: "Failed", value: "failed" },
];

// Invoice Date range or payment received date range
export const InvoiceOrPaymentDropdown = [
  { name: "Invoice Date Range", value: "Invoice Range" },
  { name: "Payment Received Date Range", value: "Payment Received Range" },
  { name: "Due Date", value: "Due Date" },
];

// sub contractor payment status dropdown
export const SubContractorPaymentDropdown = [
  { name: "Period End Date Range", value: "Period End Date Range" },
  { name: "E-Transfer Date Range", value: "E-Transfer Date Range" },
];

// sub contractor payment mode dropdown
export const PaymentModeSubContractorDropdown = [
  { name: "E-Transfer", value: "E-Transfer" },
  { name: "Cheque", value: "Cheque" },
];

// percentage dropdown
export const percentageOptions = [
  { name: "125 (More Tax)", value: "125" },
  { name: "100 (Regular Tax)", value: "100" },
  { name: "75 (Less Tax)", value: "75" },
  { name: "50 (Half Tax)", value: "50" },
  { name: "0 (No Tax)", value: "0" },
];

// employee status dropdown
export const EmployeeStatusDropdown = [
  { name: "Active", value: "Active" },
  { name: "Paid leave of absence", value: "Paid leave of absence" },
  { name: "Unpaid leave of absence", value: "Unpaid leave of absence" },
  { name: "Terminated", value: "Terminated" },
  { name: "Not on payroll", value: "Not on payroll" },
  { name: "Deceased", value: "Deceased" },
];

// Provinces
export const provinces = [
  "Alberta",
  "British Columbia",
  "Manitoba",
  "New Brunswick",
  "Newfoundland and Labrador",
  "Northwest Territories",
  "Nova Scotia",
  "Nunavut",
  "Ontario",
  "Prince Edward Island",
  "Quebec",
  "Saskatchewan",
  "Yukon",
];

// Custom Month modal state
export const allMonths = [
  { label: "January", value: 1 },
  { label: "February", value: 2 },
  { label: "March", value: 3 },
  { label: "April", value: 4 },
  { label: "May", value: 5 },
  { label: "June", value: 6 },
  { label: "July", value: 7 },
  { label: "August", value: 8 },
  { label: "September", value: 9 },
  { label: "October", value: 10 },
  { label: "November", value: 11 },
  { label: "December", value: 12 },
];

// invoice payee payment method options
export const paymentMethodOptions = [
  { label: "E-transfer", value: "e_transfer" },
  { label: "Bank Transfer", value: "bank_transfer" },
  { label: "Payment Link", value: "payment_link" },
  { label: "Other", value: "other" },
];

// dropdown option for quaters model in pd7a
export const quaters = [
  { label: "Monthly", value: "Monthly" },
  { label: "Quarterly", value: "Quarterly" },
  { label: "Custom Month", value: "CustomMonth" },
];

// dropdown option to send role in unverified user list
export const UserRoleType = [
  { label: "User", value: "4" },
  { label: "Client", value: "3" },
];

//emilPattern
export const emailPattern = new RegExp(
  /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i,
);
// phone pattern
export const phonePattern = new RegExp(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/);

export const postalCodePattern = /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ ]?\d[ABCEGHJ-NPRSTV-Z]\d$/i;

// skeleton items & length
export const Skeletonitems: number[] = Array.from({ length: 10 }, (v, i) => i);

// SKELETON FOR COLUMN BODY
export function SkeletonbodyTemplate(): JSX.Element {
  return <Skeleton></Skeleton>;
}
